import moment from "moment";

interface TaskData {
  taskId: number;
  taskName: string;
  categoryId: number;
  categoryName: string;
  subCategoryId: number;
  subCategoryName: string;
  plannedStartDate: string;
  plannedEndDate: string;
  plannedDurationDays: number;
}

interface TransformedData {
  name: string;
  type?: string;
  duration?: string;
  start?: string;
  end?: string;
  children?: TransformedData[];
}

export const transformTaskData = (apiData: any[]): TransformedData[] => {
  // Group by category
  const categories = new Map<number, TransformedData>();

  apiData.forEach((task: TaskData) => {
    // Get or create category
    if (!categories.has(task.categoryId)) {
      categories.set(task.categoryId, {
        name: task.categoryName,
        type: "category",
        children: [],
      });
    }

    const category = categories.get(task.categoryId)!;

    // Get or create subcategory
    const subCategory = category?.children?.find(
      (c) => c.name === task.subCategoryName
    );

    if (subCategory) {
      // Add task to existing subcategory
      subCategory?.children?.push({
        ...task,
        name: task.taskName,
        duration: `${task.plannedDurationDays} Days`,
        start: moment(task.plannedStartDate).format('MM-DD-YYYY'),
        end: moment(task.plannedEndDate).format('MM-DD-YYYY'),
      });
    } else {
      // Create new subcategory with task
      category?.children?.push({
        name: task.subCategoryName,
        type: "subcategory",
        children: [
          {
            ...task,
            name: task.taskName,
            duration: `${task.plannedDurationDays} Days`,
            start: moment(task.plannedStartDate).format('MM-DD-YYYY'),
            end: moment(task.plannedEndDate).format('MM-DD-YYYY'),
          },
        ],
      });
    }
  });

  // Sort categories and subcategories
  return Array.from(categories.values()).map((category) => ({
    ...category,
    children: category?.children
      ?.sort((a, b) => a.name.localeCompare(b.name))
      ?.map((child) => ({
        ...child,
        children: child.children?.sort((a, b) => a.name.localeCompare(b.name)),
      })),
  }));
};